import {
  generateKey,
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
  _pick,
} from "../utils/setting";
import { checkResponse } from "../utils/checkResponse";
const contacts = {
  state: {
    list_contact: [],
    one_contact: {},
    new_contact: {},
    list_fromType: [],
    list_category: [],
    list_categoryId: [],
    total: 0,
    count: 0,
    isRead: 0,
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    getList(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/serviceContacts/list";
      if (!payload.search) delete payload.search;
      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code && res.data) {
            const { list = [], total = 0, count = 0, isRead = 0 } = res.data;
            _this.setState({
              list_contact: list,
              isRead: isRead,
              total: total,
              count: count,
            });
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
    },
    getListCategory(payload = {}, rootState) {
      // if(rootState.user &&rootState.user.user
      //     && rootState.user.user.roleId && rootState.user.user.roleId.serviceCode)
      // {
      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/serviceContacts/listCategory";
      if (!payload.search) delete payload.search;
      return fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code && res.data) {
            _this.setState({ list_category: res.data || [] });
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
      // }
      // else {
      //     clearCookie()
      // }
    },
    getListCategoryId(payload = {}, rootState) {
      // if(rootState.user &&rootState.user.user
      //     && rootState.user.user.roleId && rootState.user.user.roleId.serviceCode)
      // {
      const _this = this;
      let url =
        DomainAPI +
        Channel +
        "/api/secure/serviceContacts/listCategoryId?category=" +
        payload.category;
      if (!payload.search) delete payload.search;
      return fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code && res.data) {
            _this.setState({ list_categoryId: res.data || [] });
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
      // }
      // else {
      //     clearCookie()
      // }
    },
    getListFromType(payload = {}, rootState) {
      // if(rootState.user &&rootState.user.user
      //     && rootState.user.user.roleId && rootState.user.user.roleId.serviceCode)
      // {
      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/serviceContacts/listFromType";
      if (!payload.search) delete payload.search;
      return fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code && res.data) {
            _this.setState({ list_fromType: res.data || [] });
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
      // }
      // else {
      //     clearCookie()
      // }
    },
    update(payload = {}, rootState) {
      // if(rootState.user &&rootState.user.user
      //     && rootState.user.user.roleId && rootState.user.user.roleId.serviceCode)
      // {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/serviceContacts/update";

      return fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify(
          _pick(payload.contact, [
            "_id",
            "name",
            "phone",
            "countryCode",
            "email",
            "content",
            "gender",
            "state",
            "district",
            "city",
            "address",
            "latitude",
            "longtitude",
            "ip",
            "age",
            "category",
            "categoryId",
            "userAgent",
            "userAgentInfo",
            "socialLink",
            "socialId",
            "fromType",
            "extraData",
            "isCustomer",
          ])
        ),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          const { t } = payload;
          if (res.code === 1 && res.data) {
            _this.setState({ one_contact: res.data });

            if (payload.snackbar) {
              payload.snackbar(t("update_success"), "success");
            }
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
      // }
      // else {
      //     clearCookie()
      // }
    },
    isRead(payload = {}, rootState) {
      // if(rootState.user &&rootState.user.user
      //     && rootState.user.user.roleId && rootState.user.user.roleId.serviceCode)
      // {
      let url =
        DomainAPI +
        Channel +
        "/api/secure/serviceContacts/isRead?_id=" +
        payload._id;

      return fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code === 1) {
            let { list_contact = [], isRead } = rootState.serviceContacts;
            let find = list_contact.find((e) => e._id === payload._id);
            find.isRead = true;
            this.setState({ list_contact: list_contact, isRead: isRead - 1 });
          } else {
            // if(payload.snackbar) {
            //     payload.snackbar(res.message || 'Something went wrong', 'error')
            // }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
      // }
      // else {
      //     clearCookie()
      // }
    },
    delete(payload = {}, rootState) {
      // if(rootState.user &&rootState.user.user
      //     && rootState.user.user.roleId && rootState.user.user.roleId.serviceCode)
      // {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/serviceContacts/delete";

      return fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify({
          _id: payload._id,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          const { t } = payload;
          if (res && res.code) {
            if (payload.snackbar) {
              payload.snackbar(t("delete_success"), "success");
            }
            _this.getList();
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
      // }
      // else {
      //     clearCookie()
      // }
    },
    createCustomer(payload = {}, rootState) {
      // if(rootState.user &&rootState.user.user
      //     && rootState.user.user.roleId && rootState.user.user.roleId.serviceCode)
      // {
      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/serviceContacts/createCustomer";

      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify(payload.contact),
      })
        .then((res) => res.json())
        .then((res) => {
          const { t } = payload;
          checkResponse(res);
          if (res.code && res.data) {
            if (payload.snackbar) {
              payload.snackbar(t("create_success"), "success");
            }
            _this.getList();
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch((error) => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message,
          };
        });
      // }
      // else {
      //     clearCookie()
      // }
    },
  }),
};

export default contacts;
